const myConfiguration = {
  name: 'Funding Societies Malaysia',
  email: 'info@fundingsocieties.com.my',
  country_code: 'MY',
  country_name: 'Malaysia',
  currency: 'MYR - Malaysia Ringgit',
  currency_code: 'MYR',
  currency_symbol: 'RM',
  enableLoyaltyProgram: false,
  encryption_key: 'FS-MY',
  header_logo_classname_prefix: 'funding-societies',
  header_vertical_logo_classname_prefix: 'funding-societies-vertical',
  header_vertical_logo_path: '/assets/img/header/logo-fs-vertical.svg',
  header: {
    completeAccountActivation: {
      show: false
    },
  },
  format: {
    date: 'y-MM-dd',
    date_time: 'y-MM-dd HH:mm:ss',
    activity_date_time: 'MMM dd y HH:mm',
    decimal: '1.2-2',
    decimal_separator: '.',
    thousands_separator: ',',
    locale: 'en'
  },
  investorExposure: {
    investorExposureFirstWarningLimit: 48000,
    investorExposureSecondWarningLimit: 50000,
  },
  institution_id: 21,
  language: 'en',
  supportedLanguages: ['en', 'zh'],
  mobileAppUrl: {
    investor: {
      googlePlay: 'https://play.google.com/store/apps/details?id=com.fundingsocieties.fundingsocieties',
      appStore: 'https://apps.apple.com/my/app/funding-societies/id1108023092'
    }
  },
  meta: {
    image: '/assets/img/icon/logo.png',
    og_type: 'information',
    twitter_card: 'summary_large_image',
    twitter_site: '@FundSocietiesMy'
  },
  borrower_referral_email: {
    show: true,
    email: 'info@fundingsocieties.com.my'
  },
  intercom: {
    enable: true
  },
  portfolio: {
    showBorrowerIdentity: {
      company: true,
      name: false
    },
    tableColumnDisplay: {
      gst: true,
      withholdingTax: true
    },
    showTaxField: true,
    columnNumber: 12
  },
  wallet: {
    show: true,
  },
  investor: {
    overview: {
      bonus: true,
    },
    settings: {
      hasInvestorProfiles: false,
    },
  },
  browseLoan: {
    borrowerName: false,
    discussionForum: false,
    showOptOut: true,
    redirectToPayment: false,
    powerOfAttorney: false,
    riskDisclosureStatement: false,
    riskDisclosureStatementChecked: false,
    suitabilityAssessmentTest: false,
    suitabilityAssessmentTestChecked: false,
    personalParticularsDisclaimer: false,
    personalParticularsDisclaimerChecked: false,
    referSme: true,
    investmentInformation: false,
    investmentHistory: {
      showOutstandingDetail: true
    },
    blog: 'https://blog.fundingsocieties.com.my?utm_source=mainsite&utm_medium=organic',
    fundingProgress: {
      show: false,
      successfulLimit: 100
    },
    crowdfundingTimeLeft: {
      exact: false,
      showInSuccessLoan: false
    },
    retailInvestorInvestingLimit: {
      enable: false
    },
  },
  referral: {
    vip: true
  },
  google_tag_manager_id: 'GTM-MT6NPNC',
  sendgrid_template: {
    investor_twoFa_email_template_id: 'dc555571-20f2-413d-b335-f9b1c0eab4f2',
    borrower_twoFa_email_template_id: 'dc555571-20f2-413d-b335-f9b1c0eab4f2',
    borrower_email_template_id: '',
    investor_email_template_id: ''
  },
  referralLink: {
    borrower: window.location.origin + '/sign-up-borrower?referral=',
    investor: 'http://promo.fundingsocieties.com.my/referral-program/?r='
  },
  image_base_url: 'assets/img/MY',
  phone_prefix: '+60',
  help: {
    general: {
      zh: 'http://intercom.help/funding-societies-malaysia',
      en: 'http://intercom.help/funding-societies-malaysia'
    },
    borrower: {
      zh: 'http://intercom.help/funding-societies-malaysia',
      en: 'http://intercom.help/funding-societies-malaysia'
    },
    investor: {
      zh: 'http://intercom.help/funding-societies-malaysia',
      en: 'http://intercom.help/funding-societies-malaysia'
    },
    show: {
      publicPage: true,
      loggedInPage: true //For submenu when user already log in
    }
  },
  story: 'https://blog.fundingsocieties.com.my/our-story?utm_source=mainsite&utm_medium=organic',
  blog: 'https://blog.fundingsocieties.com.my?utm_source=mainsite&utm_medium=organic',
  learningCenter: 'https://blog.fundingsocieties.com.my/learning-center?utm_source=mainsite&utm_medium=organic',
  minimizingRiskArticle: '',
  maximizingInvestmentArticle: '',
  mediapress: 'https://blog.fundingsocieties.com.my/category/company-news-and-events?utm_source=mainsite&utm_medium=organic',
  inTheNews: '',
  facebook: 'https://www.facebook.com/fundingsocietiesmalaysia/',
  linkedin: 'https://www.linkedin.com/company/funding-societies-malaysia',
  twitter: 'https://twitter.com/fundsocietiesmy',
  line: '',
  // Navigation configurations
  referProgram: true,
  digisign: {
    loan: false,
  },
  marketingBanner: {
    showCovidCampaignBanner: true,
  },
  menu: {
    feedback: true
  },
  showPartner: false,
  showInvestorExposureBanner: true,
  showInvestorAccreditedDeclarationBanner: false,
  showAddBankAccount: true,
  showTaxInvoice: false,
  showPrivacyNoticeInvoiceFinancing: false,
  showPrivacyNoticeMalay: true,
  showPrivacyNotice: false,
  zoho_leads_owner: null,
  zoho_leads_owner_id: null,
  zoho_leads_source: 'Website Homepage Form',
  zoho_leads_source_signup: 'FS Website',
  wootricToken: 'NPS-e7eb8c13',
  boltLinkBorrowPage: 'https://fsbolt.com/web/my?utm_source=website&utm_medium=landing_page_borrow',
  applyBoltBorrowPage: 'https://fsbolt.com/web/my/business-information?utm_source=website&utm_medium=landing_page_borrow',
  disclosureNoticeLink: 'https://landing.fundingsocieties.com/membership/my/disclosure-notice.html',
  showDisclosureNotice: true,
  infoEmail: 'info@fundingsocieties.com.my',
  enable2Fa: true,
  enable2FaLogin: true,
  learnMoreAALink: 'https://intercom.help/funding-societies-malaysia/articles/2428667-auto-invest-error-messages-explained',
  enableWootric: false,
  showLegalPopup: true,
  passportExpiredMonthLimit: 6,
  careerBambooHRLink: 'https://www.linkedin.com/company/funding-societies-modalku/jobs/',
  enableRestructuredLoan: false,
  websiteTermsAndConditionPdf: '/assets/legal/FSMY Website Terms (NAS 200427).pdf',
  subDistrictDetailEnabled: false,
  navigation: {
    loginDropDown: true,
    exposeSignUpMenu: true,
    blog: {
      show: false,
      link: ''
    },
    getFunding: {
      show: false,
      link: ''
    }
  },
  authorizationConsent: {
    websiteLink: 'www.fundingsocieties.com.my'
  },
  investEmail: 'invest@fundingsocieties.com',
  prioritySettings: {
    products: [
      {
        id: 'notified_invoice_financing',
        title: 'form.setting-priority-investment.right-form.product_names.notified-invoice-financing',
        interestRateText: '10-16%',
        tenorText: '30-120',
        notePercent: 1,
        productId: 7,
        interestRate: {
          min: 10,
          max: 16
        },
        tenor: {
          min: 30,
          max: 120
        },
      },
      {
        id: 'dealer_financing',
        title: 'form.setting-priority-investment.right-form.product_names.dealer-financing',
        interestRateText: '12% gross',
        tenorText: '90 days',
        notePercent: null,
        productId: 28,
        interestRate: {
          min: 12,
          max: 12
        },
        tenor: {
          min: 90,
          max: 90
        },
      }
    ]
  },
  websitePrivacyNoticePdf: '/assets/legal/Privacy Notice (MY) (NAS 200427).pdf',
  websitePrivacyNoticeBmPdf: '/assets/legal/Privacy Notice BM (MY).pdf',
  dateRestrictions: {
    passportExpiry: 6
  },
  modalPromoBanner: false,
  showFacilityLoan: false,
  showICNumberText: false,
  statistic: {
    showDefaultRate: true,
    mediaPressButton: {
      show: true
    }
  },
  autoInvestment: {
    enableAutoInvestment: true,
    borrowerExposure: {
      show: true
    },
    borrowerExposureWarning: {
      minimumValue: 30,
      show: true
    },
    enableInvestIslamicOnlyToggle: true,
  },
  signUp: {
    allowedOTpChannel: ['sms', 'email'],
    automatedPrefilHowDidYouFindUs: {
      enable: true,
      referral: true
    }
  },
  twoFa: {
    verify: true
  },
  memberSetting: {
    agreement: {
      manualInjection: {
        show: false,
        link: ''
      }
    }
  },
  reverification: {
    show: false,
    riskDisclosure: false,
    suitabilityAssessment: false,
    hideLoanCards: false,
    eKYC: false,
  },
  withdrawal: {
    allowDecimalInput: true
  },
  footer: {
    appDownloadButton: {
      show: true
    },
    menu: {
      media: {
        show: true,
      },
      whoWeAre: {
        show: true,
        subMenu: {
          ourStory: false,
          statistics: true,
          careers: true,
          help: true,
        }
      }
    }
  },
  analytics: {
    SearchGuru: {
      investorSignUpSuccess: true
    }
  },
  showCreateNewLoanButton: true,
  showDashboardAgreementModal: false,
  searchGuruGtmId: 'GTM-PRKHK29',
  showFSCInvestment: false,
  liveCaptureDocsForEKYC: null,
  enableEsignPerInvestment: false,
};

export default myConfiguration;
